import { render } from "./act_total.vue?vue&type=template&id=669501c6&scoped=true"
import script from "./act_total.vue?vue&type=script&lang=js"
export * from "./act_total.vue?vue&type=script&lang=js"

import "./act_total.vue?vue&type=style&index=0&id=669501c6&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669501c6"]])

export default __exports__